import { Menu } from "lucide-react";
import { BusinessUnitPicker } from "./BusinessUnitPicker";
import { useSidebar } from "./ui/sidebar";
import { Button } from "@/components/ui/button";

export function MobileHeader() {
  const { isMobile, toggleSidebar } = useSidebar();

  if (isMobile) {
    return (
      <header className="absolute inset-x-0 top-0 flex items-center bg-breedr-blue-700 p-4 text-white h-20 lg:hidden justify-between print:hidden">
        <Button
          className="h-10 w-10 rounded bg-background hover:bg-background"
          onClick={toggleSidebar}
          aria-label="Open main menu"
        >
          <Menu className="h-6 w-6 self-center justify-self-center bg-background text-breedr-blue-700" />
        </Button>
        <BusinessUnitPicker />
      </header>
    );
  }
  return null;
}
